import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class IdentityService {
    constructor(private http: HttpClient) {}


   async dologin(value:any){
        return await this.http.post<any>(`${environment.apiUrl}/identity/login`,value).toPromise();
  }



  getuserwithguid(code: string) {
    return this.http.get(`${environment.apiUrl}/identity/getresetuser?guid=${code}`);
  }


  resetPasswordRequest(model: any) {
    return this.http.post(`${environment.apiUrl}/identity/resetrequest`, model);
  }

  resetPassword(model: any) {
    return this.http.post(`${environment.apiUrl}/identity/resetpassword`, model);
  }

  getUsers() {
    return this.http.get<any[]>(`${environment.apiUrl}/users`);
  }

  getStats() {
    return this.http.get<any>(`${environment.apiUrl}/dashboard/stats`);
  }
}
